import React, { useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import SessionContext from '../context/session'
import { faunaAPI } from '../api/fauna-api'
import { Button, withStyles } from '@material-ui/core'

// Components
const handleLogout = (event, faunaQueryFun, history, sessionContext) => {
  faunaQueryFun()
    .then(res => {
      toast.success('Logout successful')
      sessionContext.dispatch({ type: 'logout', data: null })
      history.push('/')
    })
    .catch(e => {
      if (e.error) {
        toast.error(e.error)
      } else {
        console.log(e)
        toast.error('Oops, something went wrong')
      }
    })

  event.preventDefault()
}

const WhiteButton = withStyles({
  root: {
    color: '#fff',
    borderColor: '#fff',
    marginLeft: '16px'
  },
})(Button);

const Logout = props => {
  const history = useHistory()
  const sessionContext = useContext(SessionContext)

  return (
    <WhiteButton
      onClick={e => handleLogout(e, () => faunaAPI.logout(false), history, sessionContext)}
      variant='outlined'
    >
      Log out
    </WhiteButton>
  
    // <button
    //   onClick={e => handleLogout(e, () => faunaAPI.logout(true), history, sessionContext)}
    //   className={'logout align-right'}
    // >
    //   Log out all sessions
    // </button>


  )
}

export default Logout
